import { render, staticRenderFns } from "./support.component.html?vue&type=template&id=2e320a34&scoped=true&external"
import script from "./support.component.ts?vue&type=script&lang=ts&external"
export * from "./support.component.ts?vue&type=script&lang=ts&external"
import style0 from "./support.component.scss?vue&type=style&index=0&id=2e320a34&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e320a34",
  null
  
)

export default component.exports